import { render, staticRenderFns } from "./ProfileBsettings.vue?vue&type=template&id=700e2a20&scoped=true"
import script from "./ProfileBsettings.vue?vue&type=script&lang=js"
export * from "./ProfileBsettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileBsettings.vue?vue&type=style&index=0&id=700e2a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e2a20",
  null
  
)

export default component.exports